<!--
Copyright 2025 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license. See LICENSE.md in the project root for license information.
-->

<div class="elevate">
  <mat-toolbar class="background">
    <mat-toolbar-row>
      <mat-icon class="mdi-24px" fontIcon="mdi-account-group"></mat-icon>
      <p>Users/Groups</p>
    </mat-toolbar-row>
    <mat-toolbar-row>
    <mat-form-field class="w-50">
      <mat-label>Search</mat-label>
      <input matInput [(ngModel)]="filterString" (keyup)="applyFilter($event)" #input autocomplete="off" />
      @if (filterString) {
        <button matSuffix mat-icon-button aria-label="Clear" (click)="clearFilter()">
          <mat-icon class="mdi-24px" fontIcon="mdi-close-circle-outline"></mat-icon>
        </button>
      }
    </mat-form-field>
    <mat-paginator [pageSizeOptions]="[10, 25, 50, 100]" aria-label="Select page of members"></mat-paginator>
  </mat-toolbar-row></mat-toolbar>
  <table mat-table matSort matSortActive="name" matSortDirection="asc" [dataSource]="dataSource" class="w-100">
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
      <td mat-cell *matCellDef="let model">
        <button mat-icon-button ngxClipboard [cbContent]="model.id"
          (cbOnSuccess)="snackBar.open('Copied to clipboard', 'Dismiss')" (click)="$event.stopPropagation()"
          title="Copy:  {{ model.id }}">
          <mat-icon class="mdi-24px" fontIcon="mdi-content-copy"></mat-icon>
        </button>
        {{ model.name }}
      </td>
    </ng-container>

    <ng-container matColumnDef="type">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Type</th>
      <td mat-cell *matCellDef="let model">
        {{ model.type }}
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let model">
        <button mat-flat-button color="primary" (click)="add(model.id, model.type)">
          Add
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell" colspan="4">
        No results found
      </td>
    </tr>
  </table>
</div>
